<template>
  <section class="all-popups">
    <all-popups></all-popups>
  </section>
</template>

<script>
  import allPopups from './allPopups'
  import {popups} from "../../mixins/popups";

  export default {
    name: 'popups',
    components: {
      allPopups,
    },
    mixins: [popups],
    computed: {
      showOverlay() {
        return this.$store.state.popups.showOverlay
      },
      showRightPopups() {
        return this.$store.state.popups.showRight
      }
    }
  }
</script>

<style scoped>

</style>
